export const WPETypeList = () => {
  return <div>WPETypeList</div>;
};
